import { render, staticRenderFns } from "./feJson.vue?vue&type=template&id=2b8273e7&"
import script from "./feJson.vue?vue&type=script&lang=js&"
export * from "./feJson.vue?vue&type=script&lang=js&"
import style0 from "./feJson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports